<template>
  <div class="test-container">
    <div class="swiper-container dib">
      <swiper :options="swiperOption" ref="mySwiper" class="swiper-box">
        <swiper-slide v-for="(item, index) in content" v-if="index" :key="index">
          <div :class="'slide' + index" class="slide-detail">
            <div class="slide-item-title">
            <img class="title-icon dib" src="../../assets/img/supplier/use-ico.png" :alt="item.title"/>
            <h2 class="title-text dib">{{item.title}}</h2>
          </div>
          <div class="slide-item-divider dib"></div>
          <div class="slide-item-content">
          {{item.desc}}
          </div> </div>
        </swiper-slide>
      </swiper>
    </div>
    <div class="select-list dib">
      <div class="select-line dib"></div>
      <ul class="select-tree tl dib">
        <li class="select-item dib" v-if="index" :class="index === swipeIndex ? 'is-active' : ''"
            @mouseenter="changeSwiper(index)"
            v-for="(item, index) in content">
          <div class="icon dib"><div class="circle-outside"><div class="circle-inside"></div></div></div>
          <h1 class="text">{{item.title}}</h1>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import * as className from '../../assets/js/dom'
export default {
  name: 'customSwiper',
  data () {
    return {
      current: 0,
      swipeIndex: 1,
      content: [{
        title: 'test',
        desc: 'test'
      }, {
        title: '公开招募',
        desc: '公开招募，触达多家供应商，简化寻源招标流程，缩短周期时间'
      }, {
        title: '实时跟踪',
        desc: '跟踪，监控和编制基于事实的供应商绩效，引导供应商改善供货'
      }, {
        title: '降低成本',
        desc: '对供应商进行不同维度的分类，降低采购总体成本'
      }, {
        title: '信息准确',
        desc: '达到一致的格式的供应商目录，可确保订单包含准确的产品和价格信息'
      }, {
        title: '数据一致',
        desc: '保持采购，库存，合同等数据的一致性，避免重复采购，信息反馈不及时'
      }, {
        title: '规避风险',
        desc: '查看仪表盘供应商采购，绩效，成交额等所有数据，降低规避风险'
      }],
      swiperOption: {
        direction: 'vertical',
        slidesPerView: 3,
        spaceBetween: 20,
        autoplay: 3000,
        centeredSlides: true,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        onTransitionEnd: function () {
          let currentDom = document.getElementsByClassName('swiper-slide-active')[0]
          let currentIndex = currentDom.getAttribute('data-swiper-slide-index') || currentDom.dataset.swiperSlideIndex
          this.swipeIndex = currentIndex
          let listDom = document.getElementsByClassName('select-item')[currentIndex]
          let prevDom = document.getElementsByClassName('select-item is-active')[0]
          className.removeClass(prevDom, 'is-active')
          className.addClass(listDom, 'is-active')
        }
      }
    }
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    }
  },
  mounted () {
    console.log(this.$refs.mySwiper.swiper)
  },
  methods: {
    changeSwiper (index) {
      this.swiper.slideTo(index + 2, 700, true)
      let currentDom = document.getElementsByClassName('swiper-slide-active')[0]
      let currentIndex = currentDom.getAttribute('data-swiper-slide-index') || currentDom.dataset.swiperSlideIndex
      let listDom = document.getElementsByClassName('select-item')[currentIndex]
      let prevDom = document.getElementsByClassName('select-item is-active')[0]
      className.removeClass(prevDom, 'is-active')
      className.addClass(listDom, 'is-active')
    }
  }
}
</script>
<style lang="scss">
  .test-container {
    text-align: center;
    width: 100%;
    height: 600px;
    .swiper-container {
      width: 700px;
      height: 500px;
      overflow: hidden;
      vertical-align: top;
      .swiper-box {
        position: relative;
        bottom:250px;
        height: 1000px;
      }
      .swiper-slide {
        text-align: left;
        width: 700px;
        // background-image: url('../../assets/img/supplier/use-contents.png');
        // background-size: cover;
        .slide-item-title {
          font-size: 0;
          .title-icon {
            width: 18px;
            height: 18px;
            vertical-align: top;
          }
          .title-text {
            font-size: 18px;
            font-weight: 400;
            line-height: 18px;
            color: #666666;
            margin-left: 10px;
          }
        }
        .slide-detail{
            height: 320px;
            padding: 28px 29px;
            background-size: cover;
        }
        .slide1{
            background-image: url('../../assets/img/supplier/bg1.png') !important;
        }
        .slide2{
            background-image: url('../../assets/img/supplier/bg2.png') !important;
        }
        .slide3{
            background-image: url('../../assets/img/supplier/bg3.png') !important;
        }
        .slide4{
            background-image: url('../../assets/img/supplier/bg4.png') !important;
        }
        .slide5{
            background-image: url('../../assets/img/supplier/bg5.png') !important;
        }
        .slide6{
            background-image: url('../../assets/img/supplier/bg6.png') !important;
        }
        .slide-item-divider {
          width: 60px;
          height: 1px;
          background-color: #24A6BF;
        }
        .slide-item-content {
          margin-top:40px;
          font-size:16px;
          font-weight:400;
          color:#666666;
          line-height:24px;
          width: 160px;
        }
      }
      .swiper-slide-prev, .swiper-slide-next {
        transform: scale(0.9,0.9);
        opacity: 0.8;
      }
    }
    .select-list {
      margin-left: 37px;
      margin-top: 81px;
      vertical-align: top;
      .select-line {
        width: 0px;
        height: 310px;
        border: 0.5px solid #EAEAEA;
        position: relative;
        z-index: 9;
        left:9px;
        top: 20px;
      }
      .select-tree {
        width: 120px;
        position: relative;
        z-index: 10;
        .select-item {
          cursor: pointer;
          user-select: none;
          margin-bottom: 36px;
          .icon {
            .circle-outside {
              width: 9px;
              height: 9px;
              border-radius: 50%;
              border: 1px solid #EAEAEA;
              background-color: #ffffff;
            }
          }
          .text {
            margin-left: 20px;
            color: #666666;
            font-size:16px;
            font-weight:400;
          }
        }
        .is-active {
          .icon {
            .circle-outside {
              width: 9px;
              height: 9px;
              border-radius: 50%;
              border: none;
              background-color: #4CBACE;
              .circle-inside {
                width: 7px;
                height: 7px;
                border-radius: 50%;
                background-color: transparent;
                border: 1px solid white;
                position: relative;
                top: 1px;
                left: 1px;
              }
            }
          }
          .text {
            color: #24A6BF;
            font-size:18px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// swiper.vue?06fed6cf